import React, { useState } from "react";
import { axiosapi } from "../api/axiosapi";

const SignupForm = (props) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();
        // handle form submission here
        const newUser = {
            name: firstName,
            email: email,
            password: password

        }
        const result = await axiosapi.post('/auth/signup', newUser);


    };

    return (
        <div>
            <p className="pt-5 text-center font-bold text-3xl ">Create Account</p>

            <form className="max-w-lg mx-auto mt-8 px-5 " onSubmit={handleSubmit}>
                <div className="mt-4">
                    <div>
                        <label htmlFor="first_name" className="block font-medium text-gray-700">
                            First Name
                        </label>
                        <input
                            id="first_name"
                            type="text"
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                    </div>

                </div>
                <div className="mt-4">
                    <label htmlFor="email" className="block font-medium text-gray-700">
                        Email
                    </label>
                    <input
                        id="email"
                        type="email"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="mt-4">
                    <label htmlFor="password" className="block font-medium text-gray-700">
                        Password
                    </label>
                    <input
                        id="password"
                        type="password"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <div className="mt-4">
                    <label htmlFor="confirm_password" className="block font-medium text-gray-700">
                        Confirm Password
                    </label>
                    <input
                        id="confirm_password"
                        type="password"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </div>
                <div className="mt-4 flex justify-center">
                    <button
                        type="submit"
                        className="py-2 px-4 w-[100%] bg-[#3399FF] text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                        Create Account
                    </button>
                </div>

            </form>
            <p className="text-center mt-4 font-bold ">Already a buddy? <span className="text-[#3399FF] font-bold cursor-pointer" onClick={() => props.onClick(true)}>Log in</span></p>
        </div>
    );
};

export default SignupForm;
